import React, { useEffect, useState } from 'react';
import LoadingIndicator from '@svb/api-loading-component/dist/components/index';
import CookieConsent, {
  // Cookies,
  getCookieConsentValue,
  // , resetCookieConsentValue
} from 'react-cookie-consent';
import { SVBQm } from '@svb/quantummetric-react-component';
// import { SVBQm } from '../extra/quantummetric-react-component';

export default function CookieConsentPolicy(props) {
  const { datatestid, baseUrl } = props;
  const [enableQM, setEnableQM] = useState(false);
  const [loading, setLoading] = useState(true);
  const [qtmSource, setqtmSource] = useState('');
  // if user accepts cookie consent
  const onCookiePolicyAccept = () => {
    setLoading(true);
    setEnableQM(true);
    setTimeout(() => {
      setLoading(false);
    }, 5);
  };
  // if user rejects cookie consent
  const onCookiePolicyDecline = () => {
    setLoading(true);
    setEnableQM(false);
    setTimeout(() => {
      setLoading(false);
    }, 5);
  };
  useEffect(() => {
    const consentVal = !datatestid ? getCookieConsentValue('SVBCookieConsent') : datatestid;
    /* istanbul ignore next */
    if (consentVal === 'true') {
      setEnableQM(true);
    } else {
      setEnableQM(false);
    }

    // set quantum metrics source based on base url
    if (baseUrl === 'beta.developer.svb.com' || baseUrl === 'developer.svb.com') {
      setqtmSource('https://cdn.quantummetric.com/qscripts/quantum-svb.js');
    } else {
      setqtmSource('https://cdn.quantummetric.com/qscripts/quantum-svbpreprod.js');
    }

    setLoading(false);
  }, []);

  return loading ? (
    <LoadingIndicator />
  ) : enableQM ? (
    <SVBQm
      enabled={
        process.env.REACT_APP_QTM_ENABLE &&
        process.env.REACT_APP_QTM_ENABLE.toLowerCase() === 'false'
          ? false
          : true
      }
      qtmsrc={qtmSource}
    />
  ) : (
    <>
      <SVBQm enabled={false} qtmsrc={qtmSource} />
      <CookieConsent
        cookieName='SVBCookieConsent'
        onAccept={() => onCookiePolicyAccept()}
        onDecline={() => onCookiePolicyDecline()}
        location='bottom'
        buttonText='OK'
        flipButtons
        enableDeclineButton
        declineButtonText='X'
        containerClasses='cookie-containerClass'
        buttonClasses='cookie-buttonClass'
        declineButtonClasses='cookie-declineButtonClass'
        sameSite='strict'
        cookieSecurity={true}
      >
        {`By clicking "OK", you agree to the storing of cookies on your device for the purposes of analyzing the usage of this site.`}
      </CookieConsent>
    </>
  );
}
